var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVideo5 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.044 85.092c-0.328 0-0.652-0.080-0.948-0.24-0.648-0.348-1.052-1.024-1.052-1.76v-46.184c0-0.736 0.404-1.412 1.052-1.76s1.432-0.316 2.048 0.092l35 23.088c0.564 0.372 0.904 1 0.904 1.672s-0.336 1.3-0.904 1.668l-35 23.096c-0.332 0.22-0.716 0.328-1.1 0.328zM51.044 40.62v38.756l29.368-19.38-29.368-19.376z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 4c30.88 0 56 25.12 56 56 0 30.884-25.12 56-56 56s-56-25.116-56-56c0-30.88 25.12-56 56-56zM60 0c-33.136 0-60 26.864-60 60s26.864 60 60 60c33.14 0 60-26.864 60-60s-26.868-60-60-60v0z",
    fill: "#000000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideo5, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Video-5.e848a041.svg";
export { ForwardRef as ReactComponent };